import styled from 'styled-components';
import { transparentize } from 'polished';
//
import colors from 'theme/colors';

const { darkBackgroundElevation1, white } = colors;

export const Controls = styled.div`
  padding: 16px 0px 0px;
`;

export const PriceContainer = styled.div`
  margin-top: 16px;
`;
export const PriceLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
`;

export const BubblyContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;

  & > button {
    margin-right: 8px;
  }
`;

export const ControlGroup = styled.div`
  display: flex;
  align-items: center;
`;

export const Control = styled.div`
  min-width: 128px;
  padding-right: 32px;
`;

export const Container = styled.div``;

export const NoProducts = styled.div`
  padding: 60px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NoDataContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(45vw * 0.667);
`;

export const Visual = styled.div``;

const colorGradientHigh = 0.3;

export const LineGraphContainer = styled.div`
  background-color: ${white};

  .overlay {
    fill: none;
    pointer-events: all;
  }

  .focus circle {
    fill: ${transparentize(colorGradientHigh, darkBackgroundElevation1)};
    box-shadow: 0.5px 0.5px 2px #979797;
  }

  .focus text {
    font-size: 12px;
    fill: white;
  }

  .tooltip {
    fill: ${transparentize(colorGradientHigh, darkBackgroundElevation1)};
    box-shadow: 0.5px 0.5px 2px #979797;
  }

  .price-date {
    font-weight: bold;
  }
`;
